import type { ILeadRepository } from "../repositories/lead.repository";
import type { Lead, LeadCreateInput } from "@/types/models";

export interface ILeadService {
  submitLead(input: LeadCreateInput): Promise<Lead>;
  getLeads(): Promise<Lead[]>;
}

export class LeadService implements ILeadService {
  constructor(private readonly repository: ILeadRepository) {}

  async submitLead(input: LeadCreateInput): Promise<Lead> {
    if (!input.fullName?.trim() || !input.email?.trim()) {
      throw new Error("Nama lengkap dan email wajib diisi.");
    }
    return this.repository.create(input);
  }

  async getLeads(): Promise<Lead[]> {
    return this.repository.list();
  }
}
